import React, {useState} from 'react'
import _ from 'lodash'
import './HotspotPlacementTool.scss'

const HotspotPlacementTool = props => {

    const debug = true;
    const [debugHotspot, setdebugHotspot] = useState( props.style || {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
    });

    const targetFrameClass = props.target || '.scene-bg';

    const [debugDragging, setDebugDragging] = useState(false);
    const [debugResize, setDebugResize] = useState(false);
    const [debugOffsets, setDebugOffsets] = useState({
        top:50,
        left:50
    });


    
    const onDebugMouseDown = (e) => {
        if(e.target !== e.currentTarget) return;

        //start dragging
        if(!debugDragging){
            setDebugDragging(true)
            setDebugResize(false)
            const notice = document.querySelector('.copied-notification');
            notice.innerHTML = ""
        }
    }
  
    const onDebugMouseMove = (e) => {
        //update coords if dragging
        if(!debugDragging) return;
        //get mouse coords relative to topleft of background
        const bgDOM = document.querySelector(targetFrameClass);
        const box = bgDOM.getBoundingClientRect();

        const leftOffset = box.left + debugOffsets.left;
        const topOffset = box.top + debugOffsets.top;
        const left = e.nativeEvent.pageX -  leftOffset;
        const top = e.nativeEvent.pageY - topOffset;
        let temp = _.clone(debugHotspot);
        temp.top = top;
        temp.left = left;
        setdebugHotspot(temp);
    }

    const onDebugResizeMouseDown = (e) => {
        e.preventDefault();
         //start resize
         if(!debugDragging){
            setDebugResize(true)
            setDebugDragging(false)
            const notice = document.querySelector('.copied-notification');
            notice.innerHTML = ""
        }
    }

    const onDebugResizeMouseMove = (e) => {
        const bgDOM = document.querySelector('.debug-hotspot');
        const box = bgDOM.getBoundingClientRect();
        const leftOffset = box.left - 5;
        const topOffset = box.top - 5;
        const width = e.nativeEvent.pageX -  leftOffset;
        const height = e.nativeEvent.pageY - topOffset;
        let temp = _.clone(debugHotspot);
        temp.height = height;
        temp.width = width;
        setdebugHotspot(temp);
      
    }

    const onBGMouseMove = (e) => {
        if(!debug) return;
        if(debugDragging){
            onDebugMouseMove(e)
        }
        else if(debugResize){
            onDebugResizeMouseMove(e)
        }
    }
    
    const copyToClipboard = (text) => {
        let fake = document.createElement("textarea");
        fake.value = text;
        document.body.appendChild(fake);
        fake.select();
        document.execCommand("copy");
        document.body.removeChild(fake);

        const notice = document.querySelector('.copied-notification');
        notice.innerHTML = "Copied to clipboard."
    }

    const onBGMouseUp = (e) => {
        if(!debug) return;
        copyToClipboard(JSON.stringify(debugHotspot, null, 2));
        setDebugDragging(false)
        setDebugResize(false)
        setDebugOffsets({
            top:Math.round(debugHotspot.height/2),
            left:Math.round(debugHotspot.width/2),
        })
    }

    return (
        <div className="HotspotPlacementTool">
             <div className={`bg-listener`}
                style={{
                    position:'absolute', 
                    top:0,
                    left:0,
                    height:'100%',
                    width:'100%',
                    zIndex: (debugResize || debugDragging) ? 999 : -1
                }}
                onMouseUp={onBGMouseUp}
                onMouseMove={onBGMouseMove}
            >
                <div className={`hotspot debug debug-hotspot`} 
                    style={debugHotspot} 
                        onMouseDown={onDebugMouseDown} 
                    >
                        <div className={`text`}>
                            <pre>{JSON.stringify(debugHotspot, null, 2)}</pre>
                        </div>
                        <text className={`copied-notification`}></text>
                        <div className={`resize`}
                            onMouseDown={onDebugResizeMouseDown} 
                        ></div>
                        </div>

            </div>


        </div>
    )
}

export default HotspotPlacementTool